import { render, staticRenderFns } from "./progressDetail2.vue?vue&type=template&id=58b80a2e&scoped=true&"
import script from "./progressDetail2.vue?vue&type=script&lang=js&"
export * from "./progressDetail2.vue?vue&type=script&lang=js&"
import style0 from "./progressDetail2.vue?vue&type=style&index=0&id=58b80a2e&prod&lang=scss&scoped=true&"
import style1 from "./progressDetail2.vue?vue&type=style&index=1&id=58b80a2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b80a2e",
  null
  
)

export default component.exports